/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';

import Button from 'components/Button';
import DeviceActions from 'actions/DeviceActions';
import TitleHeader from 'components/TitleHeader';

import 'styles/utilities.scss';

class ConfirmEmail extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    uid: PropTypes.string.isRequired,
    onGoBack: PropTypes.func,
  };

  componentDidMount() {
    DeviceActions.resendConfirmationEmail(this.props.uid);
  }

  render() {
    return (
      <div className="ConfirmEmail">
        <TitleHeader title="Check your email to continue" />
        <p className="block">
          It looks like you’ve already used Remind, so we sent you a confirmation email. Click on
          the link in the email to finish signing up for Remind!
        </p>
        <Button level="text" onClick={this.props.onGoBack}>
          Go back
        </Button>
      </div>
    );
  }
}
export default ConfirmEmail;
